import { Link, useRouterState } from '@tanstack/react-router';
import clsx from 'clsx';
import { useReadUrl } from '../../../hooks/useReadUrl';

interface BookmarkTitleProps {
  bookmarkId: string;
  title: string;
  url: string;
  isLoggedIn: boolean;
  condensedView: boolean;
  profileMode: boolean;
  isBatchMode?: boolean;
}

function BookmarkTitle({
  bookmarkId,
  title,
  url,
  isLoggedIn,
  condensedView,
  profileMode,
  isBatchMode,
}: BookmarkTitleProps) {
  const routerState = useRouterState();
  const { to, params, search } = useReadUrl(bookmarkId);
  const displayTitle = title || url;
  const isUrl = !title || title.startsWith('http://') || title.startsWith('https://');
  const titleClassName = clsx(
    'no-underline text-bookmark-title',
    'text-copy-primary line-clamp-3 md:line-clamp-2',
    isUrl ? 'break-all' : 'break-words',
  );

  const handleLinkClick = (event: React.MouseEvent) => {
    // In batch mode, prevent the link from navigating/opening a new tab.
    // The row-level click handler will handle selection instead.
    if (isBatchMode) {
      event.preventDefault();
    }
  };

  return (
    <h2
      className={clsx(
        'bookmark-title',
        condensedView && 'condensed',
        profileMode && 'profile-title',
      )}
    >
      {isLoggedIn && !profileMode ? (
        <Link
          to={to}
          params={params}
          search={search}
          className={titleClassName}
          state={{ from: routerState.location.pathname }}
          onClick={handleLinkClick}
        >
          {displayTitle}
        </Link>
      ) : (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className={titleClassName}
        >
          {displayTitle}
        </a>
      )}
    </h2>
  );
}

export default BookmarkTitle;
